import Icon from '../components/Icon.vue'

Icon.register({
  'hand-paper': {
    width: 447,
    height: 512,
    paths: [
      {
        d: 'M408.8 128c21.7 0.4 39.2 18.2 39.2 40v150.4c0 12.3-2.3 32-5.1 44l-26.5 112.7c-5.1 21.7-24.5 37-46.7 37h-197.6c-13.5 0-30.9-8.9-38.8-19.8l-125.6-172.7c-13-17.9-9-42.9 8.8-55.9 17.9-13 42.9-9 55.9 8.8l31.6 43.5v-236c0-21.8 17.5-39.6 39.2-40 22.4-0.4 40.8 18.4 40.8 40.8v175.2h8v-216c0-21.8 17.5-39.6 39.2-40 22.4-0.4 40.8 18.4 40.8 40.8v215.2h8v-177c0-21.8 17.5-39.6 39.2-40 22.4-0.4 40.8 18.4 40.8 40.8v176.2h8v-87.2c0-22.4 18.4-41.2 40.8-40.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-paper.js
// module id = null
// module chunks = 